// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <div class="detail-view">
    <v-container fluid grid-list-md>
      <v-card>
        <v-toolbar flat>
          <v-btn icon @click="exit" v-if="!noPathId"><v-icon>clear</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn class="mx-1" v-if="canModify" light color="success" @click="saveItem(false)">Save</v-btn>
          <v-btn class="mx-1" v-if="canDelete" light color="error" @click.stop="showDeleteDialog = true">Delete</v-btn>
        </v-toolbar>
        <v-card-text>
          <template>
            <v-row wrap>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Name"
                  v-model="values.name"
                  hide-details
                  ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Image"
                  v-model="values.image"
                  hide-details
                  ></v-text-field>
              </v-col>
              <v-col cols="6" md="3">
                <v-text-field
                  label="Top Left (X)"
                  v-model.number="values.topLeft[0]"
                  @change="(val) => convertFloat(val)"
                  hide-details
                  ></v-text-field>
              </v-col>
              <v-col cols="6" md="3">
                <v-text-field
                  label="Top Left (Y)"
                  v-model.number="values.topLeft[1]"
                  @change="(val) => convertFloat(val)"
                  hide-details
                  ></v-text-field>
              </v-col>
              <v-col cols="6" md="3">
                <v-text-field
                  label="Bottom Right (X)"
                  v-model.number="values.botRight[0]"
                  @change="(val) => convertFloat(val)"
                  hide-details
                  ></v-text-field>
              </v-col>
              <v-col cols="6" md="3">
                <v-text-field
                  label="Bottom Right (Y)"
                  v-model.number="values.botRight[1]"
                  @change="(val) => convertFloat(val)"
                  hide-details
                  ></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="showDeleteDialog" max-width="300px">
      <v-card>
        <v-card-title>
          <div class="headline">Delete?</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete this {{ name }}?  This action cannot be undone.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="showDeleteDialog = false">Cancel</v-btn>
          <v-btn text color="red" @click.native="deleteItem">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <error-snackbar v-model="errorText"></error-snackbar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import {ENDPOINT} from '@/shared/constants'
import DetailView from '@sdgsystems/vue-common/components/DetailView.vue'
import ApiRequests from '../api/ApiRequests'
import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'
import {checkPermission} from '@sdgsystems/vue-common/components/user'
import {PERMISSIONS} from '@sdgsystems/vue-common/components/constants'

export default {
  components: {
    DetailView,
    ErrorSnackbar
  },

  data () {
    return {
      errorText: '',
      endpoint: ENDPOINT,
      showDeleteDialog: false,
      values: {}
    }
  },

  props: {
    permissions: String,
    disableModify: Boolean,
    noPathId: Boolean
  },

  created () {
    if (!this.isNew) {
      ApiRequests.getMap(this.$route.params.id).then((res) => {
        this.values = res.data
      })
    } else {
      this.values = {
        name: '',
        image: '',
        site: this.selectedSite._id,
        botRight: [],
        topLeft: []
      }
    }
  },

  computed: {
    ...mapGetters([
      'selectedSite',
      'accessRules'
    ]),

    canDelete: function () {
      return checkPermission(this.accessRules, 'maps', PERMISSIONS.DELETE) && !this.isNew && !this.$props.noPathId
    },

    canModifyNoDisable: function () {
      return checkPermission(this.accessRules, 'maps', PERMISSIONS.MODIFY)
    },

    canModify: function () {
      return this.canModifyNoDisable && (!this.$props.disableModify || this.isNew)
    },

    isNew: function () {
      return this.$route.params.id === 'new'
    },

    hiddenValues: function () {
      return [{
        path: 'site',
        value: this.selectedSite._id
      }]
    }
  },

  methods: {
    convertFloat: function (str) {
      str = parseFloat(str)
    },

    deleteItem: function () {
      ApiRequests.deleteMaps(this.$route.params.id).then(response => {
        this.exit()
      }).catch(e => {
        this.errorText = 'Delete failed: ' + e.response.data
        console.log(e.response)
      })
      this.showDeleteDialog = false
    },

    exit: function () {
      this.$router.go(-1)
    },

    saveItem: function (noExit) {
      if (this.isNew) {
        ApiRequests.createMaps(this.values)
        .then(() => {
          this.errorText = 'Saved'
          this.exit()
        })
        .catch(e => {
          this.errorText = 'Failed to save: ' + e.response.data
        })
      } else {
        ApiRequests.updateMaps(this.$route.params.id, this.values)
        .then(() => {
          this.exit()
        })
        .catch(e => {
          this.errorText = 'Failed to save: ' + e.response.data
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MapEdit.vue